
import React, { useEffect, useRef, useState } from "react";
import UserInformation from "./UserInformation";
import { ACTION_CLOSE, MCard, MDialog, MSpinner } from "components/Shared";
import { InternetUserListDto } from "interfaces/Mueller.Business.Models";
import { getUser } from "requests/internetUsers/";
import { MCardAction } from "components/Shared/MCard";
import { updateEmployeeDetailsByEmployeeId } from "requests/employee";
import InternetUserSearch from "./InternetUserSearch";
import Button from "@mui/material/Button";
import { connect } from "react-redux";
import { userHasRight } from "selectors/rights";
import { AUTHENTICATION_LIST } from "typeConstants/rights";
import { InitialState } from "reducers/initialState";

interface Props {
  employeeInternetUserId: number,
  verticalDisplay: boolean,
  employeeId: number,
  canViewAuthenticationList: boolean,
}

const LinkedUsersCard = (props: Props) => {

  const [internetUser, setInternetUser] = useState<InternetUserListDto>(null);
  const [internetUserId, setInternetUserId] = useState<number>();
  const [isFetchingUser, setIsFetchingUser] = useState<boolean>(true);
  const [showLinkUserDialog, setShowLinkUserDialog] = useState<boolean>(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);

  const mounted = useRef<boolean>(true);
  
  useEffect(() => {

    let id = internetUserId || props.employeeInternetUserId;

    if(id){
      getUser(
        id,
        (user: InternetUserListDto) => {
          setInternetUser(user);
          setIsFetchingUser(false);
        },
        mounted);
    }
  },
  [internetUserId]);

  useEffect(() => {
    if(props.employeeInternetUserId !== internetUserId)
      setInternetUserId(props.employeeInternetUserId);
  },
  [props.employeeInternetUserId]);

  useEffect(() => {
    return () => {mounted.current = false;};
  },[]);

  const onAddUserButtonPress = () => {
    if(internetUserId)
      setShowConfirmationDialog(true);
    else
      setShowLinkUserDialog(true);
  };

  const cardActions: MCardAction[] = [
    { icon: "add", helpText: "Link an Internet User to this Employee", onClick: onAddUserButtonPress }
  ];

  const onInternetUserSelected = (user: InternetUserListDto) => {
    let dto = [
        {
          key: "internetUserId",
          value: user.internetUserId
        }
      ];
    updateEmployeeDetailsByEmployeeId(props.employeeId, dto, mounted);
    setInternetUserId(user.internetUserId);
    setInternetUser(user);
    setShowLinkUserDialog(false);
  };

  const onConfirmationDialogYesPress = () => {
    setShowConfirmationDialog(false);
    setShowLinkUserDialog(true);
  };

  if(isFetchingUser)
    return <MSpinner />;

  return (
    <>
      <MCard
        title="Linked Users"
        actions={props.canViewAuthenticationList ? cardActions : null}
        children={internetUserId ?
          <UserInformation
            internetUserId={internetUserId}
            userInformation={internetUser}
            canEditUser={false}
          /> : <>There is no user account associated with this employee</>}
      />
      <MDialog
        visible={showConfirmationDialog}
        title="Set Internet User"
        className="confirm-set-internet-user-dialog"
        id="set-internetuser-confirmation-dialog"
        width={600}
        height={400}>
          Web account already linked to this employee. Linking a new one will replace the existing linked account. Are you sure you want to proceed?
          <div className="confirm-set-internet-user-dialog-button-container">
            <Button onClick={onConfirmationDialogYesPress}>Yes</Button>
            <Button color="secondary" onClick={() => setShowConfirmationDialog(false)}>Cancel</Button>
          </div>
      </MDialog>
      <MDialog
        visible={showLinkUserDialog}
        title="Internet Users"
        id="internetuser-edit-dialog"
        width={800}
        actions={[{ code: ACTION_CLOSE, onClick: () => setShowLinkUserDialog(false) }]}
        height={"flex"}>
        <InternetUserSearch onInternetUserSelected={onInternetUserSelected} />
      </MDialog>
    </>
        );
};

const mapStateToProps = (state: InitialState) => ({
  canViewAuthenticationList: userHasRight(AUTHENTICATION_LIST)(state),
});

export default connect(mapStateToProps)(LinkedUsersCard);